import React from 'react';
import ProgressBar from '@ramonak/react-progress-bar';

type ProgressProps = {
  value: number;
  height?: string;
  color?: string;
  backgroundColor?: string;
  className?: string;
};

export const Progress = (props: ProgressProps) => {
  const { 
    value, 
    height = "8px", 
    color = "linear-gradient(90deg, #006D75 0%, #28B0BB 100%)", 
    backgroundColor = "#E9F6F8",
    className = ""
  } = props;
  return (
    <div className={`w-full ${className}`}>
      <ProgressBar
        completed={value} // 设置进度百分比
        baseBgColor={backgroundColor} // 背景色
        bgColor={color} // 进度条颜色
        height={height} // 进度条高度
        labelColor="#ffffff" // 标签的颜色
        labelSize="0px" // 标签的大小
        className="rounded-full" // 自定义类名
      />
    </div>
  );
};
